const STORAGE_KEY = 'cravo-tokens'

interface StoredTokens {
  token: string
  refreshToken: string
}

class TokenManager {
  private tokens: StoredTokens | null = null

  constructor() {
    this.hydrate()
  }

  private hydrate(): void {
    try {
      const raw = localStorage.getItem(STORAGE_KEY)
      if (!raw) return
      const parsed = JSON.parse(raw) as StoredTokens
      if (parsed.token && parsed.refreshToken) {
        this.tokens = parsed
      } else {
        localStorage.removeItem(STORAGE_KEY)
      }
    } catch {
      localStorage.removeItem(STORAGE_KEY)
    }
  }

  set(token: string, refreshToken: string): void {
    this.tokens = { token, refreshToken }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(this.tokens))
    } catch { /* ignore */ }
  }

  getAccessToken(): string | null {
    return this.tokens?.token ?? null
  }

  getRefreshToken(): string | null {
    return this.tokens?.refreshToken ?? null
  }

  hasTokens(): boolean {
    return this.tokens !== null
  }

  clear(): void {
    this.tokens = null
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch { /* ignore */ }
  }
}

export const tokenManager = new TokenManager()
